export default "__VITE_ASSET__3598874a__"